<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <form class="modal-card" @submit.prevent="submitForm">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-centered">{{ title }}</p>
        <button class="delete" aria-label="close" type="reset" @click="close()"></button>
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">

          <!-- Código promocional -->
          <div class="column is-12">
            <p class="section-heading">Código promocional</p>
          </div>
          <div class="column is-12 field">
            <label class="label">Código <span class="has-text-danger">*</span></label>
            <div class="control">
              <input class="input" type="text" placeholder="Ej. WALDOS2026" v-model="form.code" required>
            </div>
          </div>
          <div class="column is-6 field">
            <label class="label">Fecha de inicio <span class="has-text-danger">*</span></label>
            <div class="control">
              <input class="input" type="date" v-model="form.start_date" required>
            </div>
          </div>
          <div class="column is-6 field">
            <label class="label">Fecha de fin <span class="has-text-danger">*</span></label>
            <div class="control">
              <input class="input" type="date" v-model="form.end_date" required>
            </div>
          </div>
          <div class="column is-12 field">
            <label class="checkbox">
              <input type="checkbox" v-model="form.is_active">
              Activo
            </label>
          </div>

          <div class="column is-12"><hr class="divider"></div>

          <!-- Partner -->
          <div class="column is-12">
            <p class="section-heading">Partner</p>
          </div>
          <div class="column is-6 field">
            <label class="label">Nombre del partner</label>
            <div class="control">
              <input class="input" type="text" placeholder="Ej. Waldos" v-model="form.partner_name">
            </div>
          </div>
          <div class="column is-6 field">
            <label class="label">Código del partner</label>
            <div class="control">
              <input class="input" type="text" placeholder="Ej. WALDOS" v-model="form.partner_code">
            </div>
          </div>
          <div class="column is-12 field">
            <label class="checkbox">
              <input type="checkbox" v-model="form.partner_uses_own_prices" :disabled="!form.partner_name && !form.partner_code">
              Usa lista de precios propia
            </label>
            <p class="help">
              Con esto prendido, los equipos cargados con este código se cotizan con la lista del partner
              (Precios de partners) y no con el algoritmo. Si el equipo no está en su lista, no se puede cargar.
            </p>
          </div>

          <!-- Logo -->
          <div class="column is-6 field">
            <label class="label">Logo</label>
            <div class="logo-upload-box">
              <img v-if="form.partner_logo" :src="form.partner_logo" class="logo-preview" alt="logo">
              <div v-if="uploading.logo" class="upload-overlay">
                <span class="loader"></span>
              </div>
              <label class="file-label logo-pick-btn">
                <input class="file-input" type="file" accept="image/*" @change="(e) => handleLogoUpload(e, 'partner_logo')">
                <span class="button is-small is-light">
                  {{ form.partner_logo ? 'Cambiar' : 'Seleccionar imagen' }}
                </span>
              </label>
            </div>
          </div>

          <!-- Logo modal -->
          <div class="column is-6 field">
            <label class="label">Logo modal</label>
            <div class="logo-upload-box">
              <img v-if="form.partner_logo_modal" :src="form.partner_logo_modal" class="logo-preview" alt="logo modal">
              <div v-if="uploading.logo_modal" class="upload-overlay">
                <span class="loader"></span>
              </div>
              <label class="file-label logo-pick-btn">
                <input class="file-input" type="file" accept="image/*" @change="(e) => handleLogoUpload(e, 'partner_logo_modal')">
                <span class="button is-small is-light">
                  {{ form.partner_logo_modal ? 'Cambiar' : 'Seleccionar imagen' }}
                </span>
              </label>
            </div>
          </div>

          <div class="column is-12"><hr class="divider"></div>

          <!-- Textos del modal -->
          <div class="column is-12 is-flex is-align-items-center" style="gap: 12px;">
            <p class="section-heading" style="margin-bottom:0">Contenido del modal</p>
            <button
              type="button"
              class="button is-small is-light"
              :disabled="!form.partner_name"
              @click="applyTemplate"
              title="Aplica el texto estándar basado en el nombre del partner"
            >
              Aplicar plantilla
            </button>
          </div>
          <div class="column is-6 field">
            <label class="label">Encabezado (ES)</label>
            <div class="control">
              <input class="input" type="text" placeholder="Bienvenido cliente Waldos" v-model="form.header_modal">
            </div>
          </div>
          <div class="column is-6 field">
            <label class="label">Encabezado (EN)</label>
            <div class="control">
              <input class="input" type="text" placeholder="Welcome Waldos client" v-model="form.header_modal_eng">
            </div>
          </div>
          <div class="column is-6 field">
            <label class="label">Cuerpo (ES)</label>
            <div class="control">
              <textarea class="textarea" rows="3" placeholder="Nos complace informarte..." v-model="form.body_modal"></textarea>
            </div>
          </div>
          <div class="column is-6 field">
            <label class="label">Cuerpo (EN)</label>
            <div class="control">
              <textarea class="textarea" rows="3" placeholder="We are pleased to inform you..." v-model="form.body_modal_eng"></textarea>
            </div>
          </div>

          <div class="column is-12"><hr class="divider"></div>

          <!-- Videos -->
          <div class="column is-12">
            <p class="section-heading">Videos</p>
          </div>
          <div class="column is-4 field">
            <label class="checkbox">
              <input type="checkbox" v-model="form.video_empresa">
              Video Empresa
            </label>
          </div>
          <div class="column is-4 field">
            <label class="checkbox">
              <input type="checkbox" v-model="form.video_actualizado">
              Video Actualizado
            </label>
          </div>
          <div class="column is-4 field">
            <label class="checkbox">
              <input type="checkbox" v-model="form.video_usuarios">
              Video Usuarios
            </label>
          </div>

        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-danger" type="reset" @click="close">Cancelar</button>
        <button class="button button-givu" type="submit" :disabled="uploading.logo || uploading.logo_modal">Guardar</button>
      </footer>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ModalPromoCode',
  props: {
    close: { type: Function, default: () => {} },
    action: { type: Function, default: () => {} },
    title: { type: String, default: 'Código promocional' },
    promo: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      uploading: { logo: false, logo_modal: false },
      form: {
        code: '',
        start_date: '',
        end_date: '',
        is_active: true,
        partner_name: '',
        partner_code: '',
        partner_logo: '',
        partner_logo_modal: '',
        partner_uses_own_prices: false,
        header_modal: '',
        body_modal: '',
        header_modal_eng: '',
        body_modal_eng: '',
        video_empresa: false,
        video_actualizado: false,
        video_usuarios: false
      }
    }
  },
  methods: {
    ...mapActions(['uploadPartnerLogo']),
    formatDateForInput (dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      if (isNaN(date)) return ''
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    async handleLogoUpload (event, field) {
      const file = event.target.files[0]
      if (!file) return
      const key = field === 'partner_logo' ? 'logo' : 'logo_modal'
      this.uploading[key] = true
      const result = await this.uploadPartnerLogo(file)
      this.uploading[key] = false
      if (result && result.url) {
        this.form[field] = result.url
      }
      event.target.value = ''
    },
    applyTemplate () {
      const name = this.form.partner_name
      if (!name) return
      this.form.header_modal = `Bienvenido cliente ${name}`
      this.form.body_modal = `Nos complace informarte que Givu en colaboración con ${name}, te ofrece la posibilidad de vender tu celular de manera rápida y segura.`
      this.form.header_modal_eng = `Welcome ${name} client`
      this.form.body_modal_eng = `We are pleased to inform you that Givu, in collaboration with ${name}, offers you the possibility to sell your cell phone quickly and safely.`
    },
    submitForm () {
      if (!this.form.code || !this.form.start_date || !this.form.end_date) return
      this.action({ ...this.form })
    }
  },
  beforeMount () {
    if (this.promo && this.promo.id) {
      this.form.code = this.promo.code || ''
      this.form.start_date = this.formatDateForInput(this.promo.start_date)
      this.form.end_date = this.formatDateForInput(this.promo.end_date)
      this.form.is_active = this.promo.is_active !== undefined ? this.promo.is_active : true
      this.form.partner_name = this.promo.partner_name || ''
      this.form.partner_code = this.promo.partner_code || ''
      this.form.partner_logo = this.promo.partner_logo || ''
      this.form.partner_logo_modal = this.promo.partner_logo_modal || ''
      this.form.partner_uses_own_prices = !!this.promo.partner_uses_own_prices
      this.form.header_modal = this.promo.header_modal || ''
      this.form.body_modal = this.promo.body_modal || ''
      this.form.header_modal_eng = this.promo.header_modal_eng || ''
      this.form.body_modal_eng = this.promo.body_modal_eng || ''
      this.form.video_empresa = this.promo.video_empresa || false
      this.form.video_actualizado = this.promo.video_actualizado || false
      this.form.video_usuarios = this.promo.video_usuarios || false
    }
  }
}
</script>

<style scoped>
.modal-card {
  width: 760px;
  max-width: 95vw;
}
.modal-card-body {
  overflow-y: auto;
  max-height: 70vh;
}
.section-heading {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #7a7a7a;
  margin-bottom: 8px;
}
.divider {
  margin: 4px 0;
  background-color: #ededed;
}
.logo-upload-box {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
.logo-preview {
  width: 100%;
  max-height: 100px;
  object-fit: contain;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  background: #fafafa;
  padding: 4px;
}
.upload-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255,255,255,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader {
  width: 20px;
  height: 20px;
  border: 3px solid #dbdbdb;
  border-top-color: #039DA1;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
.logo-pick-btn {
  cursor: pointer;
}
</style>
